





















import { Component, Vue } from 'vue-property-decorator';
import { MUTATE_SHOW_WELCOME_MESSAGE } from '@/store/modules/interface';
import Tabs from '@/components/global/Tabs.vue';

@Component({
    components: {
        Tabs,
    },
})
export default class Settings extends Vue {
    public tabItems = [
        {
            label: 'Profile',
            name: 'profile-settings',
        },
        {
            label: 'Wallet',
            name: 'wallet',
        },
    ];

    public created() {
        // if the account is login with email then show security change password
        if (this.isLoginByEmail) {
            this.tabItems.splice(1, 0, {
                label: 'Security',
                name: 'security',
            });
        }
    }

    get isLoginByEmail(): boolean {
        return this.$store.getters.getAuth.isLoginByEmail;
    }
}
